import { render } from "./AmetistPromotion.vue?vue&type=template&id=ebd2e87e&scoped=true&ts=true"
import script from "./AmetistPromotion.vue?vue&type=script&lang=ts"
export * from "./AmetistPromotion.vue?vue&type=script&lang=ts"

import "./AmetistPromotion.vue?vue&type=style&index=0&id=ebd2e87e&scoped=true&lang=scss"

import exportComponent from "/Users/alex/lab_dev_test/info-global/info_front_new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebd2e87e"]])

export default __exports__